'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _VstComponent2 = require('./VstComponent');

var _VstComponent3 = _interopRequireDefault(_VstComponent2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _VstButton = require('./VstButton');

var _VstButton2 = _interopRequireDefault(_VstButton);

var _VstInput = require('./VstInput');

var _VstInput2 = _interopRequireDefault(_VstInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var info = function info(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '12',
      height: '12',
      viewBox: '0 0 12 12'
    }, props),
    _react2.default.createElement('path', {
      fill: '#777',
      className: 'st0',
      d: 'M6 .9c2.8 0 5.1 2.3 5.1 5.1S8.8 11.1 6 11.1.9 8.8.9 6 3.2.9 6 .9M6 0C2.7 0 0 2.7 0 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z'
    }),
    _react2.default.createElement('path', {
      fill: '#777',
      className: 'st0',
      d: 'M4.8 9.3c.2 0 .3-.1.4-.1 0-.1.1-.2.1-.5V5.6c0-.2 0-.4-.1-.4-.1-.1-.2-.1-.4-.1v-.3h2v4c0 .2 0 .4.1.4.1.1.2.1.4.2v.2H4.8v-.3zm.7-6.7c.1-.1.3-.2.5-.2s.4.1.6.2c.1.2.2.4.2.6s-.1.4-.2.6c-.2.1-.4.2-.6.2-.2 0-.4-.1-.5-.2-.2-.2-.3-.4-.3-.6 0-.2.1-.4.3-.6z'
    })
  );
};

var success = function success(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '94',
      height: '94',
      viewBox: '0 0 94 94',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'title',
      null,
      'success_icon'
    ),
    _react2.default.createElement(
      'g',
      {
        fill: '#21A921',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        d: 'M29.301 45.086a4.064 4.064 0 0 0-2.88-1.191 4.068 4.068 0 0 0-2.88 1.19 4.079 4.079 0 0 0 0 5.762l14.227 14.228a4.08 4.08 0 0 0 5.761 0L70.46 38.144a4.08 4.08 0 0 0 0-5.761 4.082 4.082 0 0 0-5.76 0l-24.05 24.05L29.3 45.087z'
      }),
      _react2.default.createElement('path', {
        d: 'M47 4C23.29 4 4 23.29 4 47s19.29 43 43 43 43-19.29 43-43S70.71 4 47 4m0 90C21.084 94 0 72.916 0 47S21.084 0 47 0s47 21.084 47 47-21.084 47-47 47'
      })
    )
  );
};

var error = function error(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      width: '94',
      height: '94',
      viewBox: '0 0 94 94',
      xmlns: 'http://www.w3.org/2000/svg'
    }, props),
    _react2.default.createElement(
      'title',
      null,
      'error_icon'
    ),
    _react2.default.createElement(
      'g',
      {
        fill: '#F64250',
        fillRule: 'evenodd'
      },
      _react2.default.createElement('path', {
        d: 'M47 71.313a5.758 5.758 0 1 1 0-11.517 5.758 5.758 0 0 1 0 11.517M50.996 51.505a2.065 2.065 0 0 1-2.058 1.892h-3.877a2.065 2.065 0 0 1-2.058-1.892l-2.215-26.582a2.064 2.064 0 0 1 2.057-2.235h8.308a2.064 2.064 0 0 1 2.058 2.236l-2.215 26.58z'
      }),
      _react2.default.createElement('path', {
        d: 'M47 4C23.29 4 4 23.29 4 47s19.29 43 43 43 43-19.29 43-43S70.71 4 47 4m0 90C21.084 94 0 72.916 0 47S21.084 0 47 0s47 21.084 47 47-21.084 47-47 47'
      })
    )
  );
};

var x = function x(props) {
  return _react2.default.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      width: '10',
      height: '10',
      viewBox: '0 0 10 10'
    }, props),
    _react2.default.createElement('path', {
      fill: '#757575',
      d: 'M10 1.1L8.9 0 5 3.9 1.1 0 0 1.1 3.9 5 0 8.9 1.1 10 5 6.1 8.9 10 10 8.9 6.1 5z'
    })
  );
};

var VstToast = function (_VstComponent) {
  _inherits(VstToast, _VstComponent);

  function VstToast(props) {
    _classCallCheck(this, VstToast);

    var _this = _possibleConstructorReturn(this, (VstToast.__proto__ || Object.getPrototypeOf(VstToast)).call(this, props));

    _this.state = {
      checked: false,
      entering: false
    };

    _this._setReadingTime = _this._setReadingTime.bind(_this);
    _this._estimateReadingTime = _this._estimateReadingTime.bind(_this);
    _this._dismiss = _this._dismiss.bind(_this);
    _this._handleCheckboxChange = _this._handleCheckboxChange.bind(_this);
    _this._customBorder = _this._customBorder.bind(_this);
    _this._customTextColor = _this._customTextColor.bind(_this);
    _this._customBackground = _this._customBackground.bind(_this);
    _this._customClosePosition = _this._customClosePosition.bind(_this);
    return _this;
  }

  _createClass(VstToast, [{
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({ entering: true });
        callback();
      }, 1);
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      this.setState({ exiting: true });
      setTimeout(function () {
        callback();
      }, 1000);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.dismissible) {
        this._setReadingTime();
      }
    }
  }, {
    key: '_setReadingTime',
    value: function _setReadingTime() {
      var _props = this.props,
          _props$title = _props.title,
          title = _props$title === undefined ? '' : _props$title,
          _props$description = _props.description,
          description = _props$description === undefined ? '' : _props$description,
          delay = _props.delay;

      var titleReadingTime = this._estimateReadingTime(title);
      var descReadingTime = this._estimateReadingTime(description);
      var totalEstimated = titleReadingTime + descReadingTime;
      var readingTime = totalEstimated > delay ? totalEstimated : delay;
      setTimeout(this._dismiss, readingTime);
    }
  }, {
    key: '_estimateReadingTime',
    value: function _estimateReadingTime(sentence) {
      if (sentence) {
        var wordsPerMinute = this.props.wordsPerMinute;
        var totalWords = sentence.trim().split(/\s+/).length;
        var readingTime = totalWords * 60 / wordsPerMinute;
        var estimatedTime = Math.round(readingTime) * 1000;
        return estimatedTime;
      }
      return this.props.delay;
    }
  }, {
    key: '_dismiss',
    value: function _dismiss() {
      this.setState({ exiting: true });
      if (this.props.onDismiss) {
        this.props.onDismiss();
      }
    }
  }, {
    key: '_handleCheckboxChange',
    value: function _handleCheckboxChange() {
      var _this3 = this;

      this.setState(function (state) {
        return { checked: !state.checked };
      }, function () {
        if (_this3.props.onCheckboxChange) {
          _this3.props.onCheckboxChange(_this3.state.checked);
        }
      });
    }
  }, {
    key: '_customBorder',
    value: function _customBorder() {
      var _props2 = this.props,
          borderColor = _props2.borderColor,
          borderPosition = _props2.borderPosition;

      if (borderColor) {
        var borders = {
          left: 'borderLeft',
          right: 'borderRight',
          top: 'borderTop',
          bottom: 'borderBottom'
        };
        var border = borders[borderPosition];
        return _defineProperty({}, border, '5px solid ' + borderColor);
      }
      return {};
    }
  }, {
    key: '_customTextColor',
    value: function _customTextColor() {
      var color = this.props.titleColor;
      if (color) {
        return { color: color };
      }
      return {};
    }
  }, {
    key: '_customBackground',
    value: function _customBackground() {
      var backgroundColor = this.props.backgroundColor;
      if (backgroundColor) {
        return { backgroundColor: backgroundColor };
      }
      return {};
    }
  }, {
    key: '_customClosePosition',
    value: function _customClosePosition() {
      var verticalAlign = this.props.closeButtonPosition;
      if (verticalAlign) {
        return { verticalAlign: verticalAlign };
      }
      return {};
    }
  }, {
    key: '_renderIcon',
    value: function _renderIcon() {
      var icons = { info: info, error: error, success: success };
      var _props3 = this.props,
          backgroundColor = _props3.backgroundColor,
          imageUrl = _props3.imageUrl,
          imgBtnFn = _props3.imgBtnFn,
          imgCoverStyle = _props3.imgCoverStyle;

      var toastIcon = imageUrl ? _react2.default.createElement(
        'div',
        { className: 'vst-toast-cover-img ' + imgCoverStyle },
        _react2.default.createElement('img', { src: imageUrl })
      ) : icons[this.props.type]();
      var verticallyCenteredIcon = void 0;
      if (imgBtnFn) {
        verticallyCenteredIcon = 'centered-icon';
        toastIcon = _react2.default.createElement(
          'div',
          { 'aria-hidden': 'true', className: 'vst-toast-button' },
          _react2.default.createElement(
            'button',
            { 'aria-hidden': 'true', id: 'toast-btn', onClick: imgBtnFn },
            toastIcon
          )
        );
      }
      return _react2.default.createElement(
        'div',
        {
          className: 'vst-toast-type vst-toast-type-' + this.props.type + ' ' + verticallyCenteredIcon,
          style: backgroundColor && { backgroundColor: backgroundColor }
        },
        toastIcon
      );
    }
  }, {
    key: '_renderDescription',
    value: function _renderDescription() {
      var style = {
        maxWidth: this.props.maxWidth + 'px'
      };
      if (this.props.description || this.props.children) {
        return _react2.default.createElement(
          'div',
          { className: 'vst-toast-description', style: style },
          this.props.description || this.props.children
        );
      }
      return null;
    }
  }, {
    key: '_renderTitle',
    value: function _renderTitle() {
      var style = {
        maxWidth: this.props.maxWidth + 'px',
        color: this.props.titleColor || ''
      };
      return _react2.default.createElement(
        'div',
        {
          className: 'vst-toast-title vst-toast-title-' + this.props.type,
          style: style
        },
        this.props.title
      );
    }
  }, {
    key: '_renderCheckbox',
    value: function _renderCheckbox() {
      var _this4 = this;

      if (this.props.checkboxText) {
        return _react2.default.createElement(
          'div',
          { className: 'vst-toast-checkbox' },
          _react2.default.createElement(_VstInput2.default, {
            id: Math.random().toString(),
            type: 'checkbox',
            name: 'checkbox',
            label: this.props.checkboxText,
            checked: this.state.checked,
            onChange: function onChange() {
              return _this4._handleCheckboxChange();
            }
          })
        );
      }
      return null;
    }
  }, {
    key: '_renderCustomRightButton',
    value: function _renderCustomRightButton() {
      return _react2.default.createElement(
        'div',
        { className: 'vst-toast-button', style: this._customClosePosition() },
        _react2.default.createElement(
          _VstButton2.default,
          { onClick: this._dismiss },
          this.props.rightButtonText
        )
      );
    }
  }, {
    key: '_renderRightButton',
    value: function _renderRightButton() {
      if (this.props.onDismiss && this.props.rightButtonText) {
        return this._renderCustomRightButton();
      }
      if (this.props.dismissible) {
        return _react2.default.createElement(
          'div',
          { className: 'vst-toast-button', style: this._customClosePosition() },
          _react2.default.createElement(
            _VstButton2.default,
            { onClick: this._dismiss },
            this.props.rightButtonText || x()
          )
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var verticalPosition = {};
      if (this.state.exiting) {
        verticalPosition = { marginTop: '-' + document.getElementById('vst-toast-ref').offsetHeight + 'px' };
      }
      return _react2.default.createElement(
        'div',
        {
          className: 'vst-toast ' + (this.props.horizontalPosition || '') + ' ' + (this.props.multipleToast || '') + ' ' + (this.props.toastOpen ? 'slide-' + this.props.verticalPosition : 'slide') + '  ' + (this.state.exiting && 'exiting') + ' ' + (this.state.entering && 'entering'),
          style: verticalPosition,
          id: 'vst-toast-ref'
        },
        _react2.default.createElement(
          'div',
          { className: 'vst-toast-container', style: this._customBorder() },
          this._renderIcon(),
          _react2.default.createElement(
            'div',
            { className: 'vst-toast-content' },
            this._renderTitle(),
            this._renderDescription(),
            this._renderCheckbox()
          ),
          this._renderRightButton()
        )
      );
    }
  }]);

  return VstToast;
}(_VstComponent3.default);

exports.default = VstToast;


VstToast.propTypes = {
  title: _propTypes2.default.string,
  children: _propTypes2.default.node,
  description: _propTypes2.default.string,
  delay: _propTypes2.default.number,
  fadeIn: _propTypes2.default.number,
  fadeOut: _propTypes2.default.number,
  maxWidth: _propTypes2.default.number,
  wordsPerMinute: _propTypes2.default.number,
  onDismiss: _propTypes2.default.func,
  onCheckboxChange: _propTypes2.default.func,
  rightButtonText: _propTypes2.default.string,
  checkboxText: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(['info', 'success', 'error']),
  titleColor: _propTypes2.default.string,
  backgroundColor: _propTypes2.default.string,
  borderColor: _propTypes2.default.string,
  imageUrl: _propTypes2.default.string,
  imgBtnFn: _propTypes2.default.func,
  imgCoverStyle: _propTypes2.default.string,
  borderPosition: _propTypes2.default.oneOf(['top', 'bottom', 'left', 'right']),
  closeButtonPosition: _propTypes2.default.oneOf(['top', 'middle']),
  multipleToast: _propTypes2.default.oneOf(['second', 'third'])
};

VstToast.defaultProps = {
  dismissible: false,
  delay: 5000,
  fadeIn: 400,
  fadeOut: 400,
  maxWidth: 500,
  wordsPerMinute: 120,
  type: 'info',
  imgBtnFn: null,
  closeButtonPosition: 'top'
};


/** WEBPACK FOOTER **
 ** ./~/vstui/lib/components/VstToast.js
 **/